<div class="page">
  <p class="textComingSoon">Coming <span style="color: #5800bf">soon!</span></p>
</div>
